(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ild-oct2-tuning-paths"] && !Shopify.designMode) return;
  try {
    
(function(){
  function preserveReview(){
    var current=new URL(window.location.href);
    var preview=current.searchParams.get('preview_theme_id');
    if(!preview)return;
    document.querySelectorAll('.ild-tuning-paths a[href]').forEach(function(link){
      var target=new URL(link.getAttribute('href'),window.location.origin);
      if(target.origin!==window.location.origin)return;
      target.searchParams.set('preview_theme_id',preview);
      link.setAttribute('href',target.pathname+target.search+target.hash);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',preserveReview,{once:true});
  else preserveReview();
  document.addEventListener('shopify:section:load',preserveReview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironline-premium-home"] && !Shopify.designMode) return;
  try {
    
  function initializeIronlineHeadlineVideos(root) {
    root.querySelectorAll('.il-home__hero-video').forEach(function (video) {
      if (video.dataset.ironlineReady) return;
      video.dataset.ironlineReady = 'true';
      video.muted = true;
      var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!motionPreference.matches) {
        var playback = video.play();
        if (playback) playback.catch(function () {});
      }
      motionPreference.addEventListener('change', function (event) {
        if (event.matches) video.pause();
      });
    });
  }
  initializeIronlineHeadlineVideos(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeIronlineHeadlineVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironline-support-center"] && !Shopify.designMode) return;
  try {
    
class IronlineSupportCenter extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.views = {ticket:'support-ticket',ezlynk:'ezlynk-instructions',hardware:'hardware-instructions',tracking:'order-tracking'};
    this.hashViews = {'#support-request':'ticket','#contact_form':'ticket','#get-files':'ezlynk','#file-guide':'ezlynk','#file-access':'ezlynk','#installation-guides':'hardware','#track-packages':'tracking','#after-order':'overview'};
    const params = new URLSearchParams(location.search);
    const feedback = this.querySelector('[data-ticket-feedback]');
    const mode = feedback ? 'ticket' : this.hashViews[location.hash] || this.dataset.initialView;
    this.show(mode);
    this.prefill(params);
    this.addEventListener('ironline:help-selection', event => this.contextLinks(event.detail), {signal:this.controller.signal});
    window.addEventListener('hashchange', () => { if (this.hashViews[location.hash]) this.show(this.hashViews[location.hash]); }, {signal:this.controller.signal});
    this.contextLinks(Object.fromEntries(params));
  }
  disconnectedCallback() { this.controller?.abort(); }
  show(mode) {
    this.dataset.currentView = mode;
    this.querySelectorAll('[data-support-view]').forEach(node => node.hidden = !node.dataset.supportView.split(' ').includes(mode));
    this.querySelectorAll('[data-support-nav]').forEach(link => { if (link.dataset.supportNav === mode) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current'); });
    const help = this.querySelector('ironline-help');
    if (help) { help.dataset.supportMode = mode; if (help.provider) help.update(); }
    const url = new URL(location.href);
    if (this.views[mode]) url.searchParams.set('view',this.views[mode]);
    else url.searchParams.delete('view');
    if (url.href !== location.href) history.replaceState(history.state,'',url);
    const target = this.hashViews[location.hash] ? document.getElementById(location.hash.slice(1)) : null;
    if (target) {
      let node = target;
      while (node && node !== this) { if (node.tagName === 'DETAILS') node.open = true; node = node.parentElement; }
      requestAnimationFrame(() => { if (target.getClientRects().length) target.scrollIntoView({block:'start'}); });
    }
  }
  prefill(params) {
    const types = {fitment:'Pre-purchase fitment',quote:'Pricing or custom quote',followup:'Follow-up on an existing request',files:'Files, AutoAgent, codes, or technical',tracking:'Order status or tracking',guides:'Installation or hardware'};
    const select = this.querySelector('[name="contact[Request type]"]');
    if (select && types[params.get('request')]) select.value = types[params.get('request')];
    const technical = this.querySelector('[data-ticket-technical]');
    const reveal = () => {
      const troubleshooting = /Installation|Files/.test(select?.value || '');
      const needsTruck = troubleshooting || /fitment/.test(select?.value || '');
      if (technical && needsTruck) technical.open = true;
      this.querySelectorAll('[data-technical-required]').forEach(input => input.required = troubleshooting);
      const requirements = this.querySelector('[data-troubleshooting-fields]');
      if (requirements) requirements.hidden = !troubleshooting;
      this.querySelectorAll('[data-troubleshooting-required]').forEach(input => { input.required = troubleshooting; input.disabled = !troubleshooting; });
    };
    select?.addEventListener('change',reveal,{signal:this.controller.signal});
    reveal();
    const year = this.querySelector('[data-technical-required][name="contact[Truck year]"]');
    if (year && params.get('year')) year.value = params.get('year').replace(/-/g,'–');
    const provider = this.querySelector('[data-technical-required][name="contact[Calibration provider]"]');
    if (provider && ['ironline','asap'].includes(params.get('provider'))) provider.value = params.get('provider') === 'asap' ? 'ASAP Calibrations' : 'Ironline Tuning';
  }
  contextLinks(values) {
    this.querySelectorAll('[data-support-route]').forEach(link => {
      const url = new URL(link.getAttribute('href'),location.origin);
      if (url.pathname !== '/pages/contact') return;
      for (const key of ['provider','platform','year','exhaust']) {
        if (key === 'provider' && link.hasAttribute('data-provider-choice')) continue;
        if (values[key]) url.searchParams.set(key,values[key]); else url.searchParams.delete(key);
      }
      if (link.hasAttribute('data-provider-choice') && ['#get-files','#file-guide','#file-access'].includes(location.hash)) url.hash = location.hash;
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      link.href = url.pathname+url.search+url.hash;
    });
  }
}
if (!customElements.get('ironline-support-center')) customElements.define('ironline-support-center',IronlineSupportCenter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironline-support-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ild-answer').forEach(root => {
 const search=root.querySelector('[data-answer-search]');
 const items=Array.from(root.querySelectorAll('[data-answer-item]'));
 const empty=root.querySelector('[data-answer-empty]');
 search.addEventListener('input',()=>{const q=search.value.trim().toLocaleLowerCase();items.forEach(item=>item.hidden=!item.textContent.toLocaleLowerCase().includes(q));empty.hidden=items.some(item=>!item.hidden);});
 const openLinkedAnswer=()=>{
  const target=items.find(item=>item.id===window.location.hash.slice(1));
  if(!target) return;
  search.value='';
  items.forEach(item=>item.hidden=false);
  empty.hidden=true;
  target.open=true;
  target.scrollIntoView({block:'start'});
 };
 openLinkedAnswer();
 window.addEventListener('hashchange',openLinkedAnswer);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironline-work-walkthrough"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ironline-work-walkthrough'))customElements.define('ironline-work-walkthrough',class extends HTMLElement{
  connectedCallback(){
    const video=this.querySelector('video'),button=this.querySelector('button'),caption=this.querySelector('[data-walkthrough-caption]'),captions=JSON.parse(this.querySelector('[data-captions]').textContent);
    button.addEventListener('click',async()=>{if(!video.paused){video.pause();return}video.muted=true;if(video.currentTime<7||video.currentTime>=23.1)video.currentTime=7;try{await video.play()}catch{button.textContent=button.dataset.playLabel}});
    video.addEventListener('play',()=>{button.textContent=button.dataset.pauseLabel});
    video.addEventListener('pause',()=>{button.textContent=button.dataset.playLabel});
    video.addEventListener('loadedmetadata',()=>{if(video.currentTime<7)video.currentTime=7});
    video.addEventListener('timeupdate',()=>{const current=[...captions].reverse().find(item=>video.currentTime>=item.time);if(current)caption.textContent=current.label;if(video.currentTime>=23.2){video.pause();if(video.currentTime>23.21)video.currentTime=23.2}});
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
